import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Video extends Component {
  constructor (props) {
    super(props);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.getSrc = this.getSrc.bind(this);
    this.state = {
      width: props.width,
      height: props.height,
      src: this.getSrc()
    };
  }
  getSrc () {
    let src = this.props.src;
    if ((!src || src === '') && this.props.embedCode) {
      var attributesArray = this.props.embedCode.split(' ');
      var result = _.find(attributesArray, (obj) => {
        return obj.indexOf('src') !== -1;
      });
      src = result.split('=')[1].replace(/"/g, '');
    }
    return src;
  }

  updateDimensions () {
    let width = this.props.width;
    let height = this.props.height;
    if (window.innerWidth <= width) {
      width = window.innerWidth;
      height = (window.innerWidth / 16) * 9;
    }
    let newState = this.state;
    newState.width = width;
    newState.height = height;
    newState.src = this.getSrc();
    this.setState(newState);
  }
  componentWillMount () {
    this.updateDimensions();
  }
  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render () {
    return (
      <span>
        <iframe title='how-it-works-video'
          src={this.getSrc()}
          width={this.state.width}
          height={this.state.height}
          frameBorder='0'
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen />
      </span>
    );
  }
}

Video.propTypes = {
  src: PropTypes.string,
  embedCode: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js